<template>
    <div class="modal fade" id="cannotDeleteQuestionAnswerModal" ref="cannotDeleteQuestionAnswerModal" tabindex="-1" role="dialog" aria-labelledby="cannotDeleteQuestionAnswerModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12 text-center">
                            <h5 class="modal-title-delete-account" id="cannotDeleteQuestionAnswerModalLabel">{{ $t('cannot_delete_question_answer.title') }}</h5>
                        </div>
                        <div class="col-12 text-left">
                            <span class="note-text">{{ $t('cannot_delete_question_answer.warning_text') }}</span>
                        </div>
                    </div>
                </div>
                <div class="modal-footer modal-footer-canvassing-grey">
                    <div class="row w-100">
                        <div class="col-12 w-100 d-flex">
                            <span data-dismiss="modal" class="modal-footer-canvassing-black-button m-auto">{{ $t('cannot_delete_question_answer.close') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CannotDeleteQuestionAnswerModal",
}
</script>